import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import PrefilledFieldShell from './PrefilledFieldShell';
import { resolveFieldMode } from '../requestDraftFieldPolicy';
import { scalarEqualsSnapshot } from '../draftFormUtils';

const FIELDS = [
  { key: 'firstName', label: 'First name' },
  { key: 'lastName', label: 'Last name' },
  { key: 'email', label: 'Email' },
  { key: 'dateOfBirth', label: 'Date of birth', type: 'date' },
  { key: 'idNumber', label: 'ID number' },
  { key: 'nationality', label: 'Nationality' },
  { key: 'countryCode', label: 'Country code' },
  { key: 'phoneNumber', label: 'Phone number' },
  { key: 'gender', label: 'Gender' },
  { key: 'addressCountry', label: 'Address country' },
  { key: 'addressState', label: 'Address state / emirate' },
  { key: 'addressCity', label: 'City' },
  { key: 'addressStreet', label: 'Street' },
  { key: 'addressZipCode', label: 'Postal / ZIP code' },
];

export default function ApplicantSection({
  applicantInfo,
  baselineApplicant,
  policy,
  onFieldChange,
  forceReadOnly = false,
}) {
  const idUrl = applicantInfo?.idImage;
  const idSummary = idUrl
    ? `${idUrl.originalName || 'ID document'} (upload #${idUrl.id})`
    : '—';

  return (
    <Card className="mb-3 shadow-sm">
      <Card.Header className="fw-semibold">Applicant information</Card.Header>
      <Card.Body>
        <Row>
          {FIELDS.map(({ key, label, type }) => {
            const path = `applicantInfo.${key}`;
            const mode = forceReadOnly
              ? 'readOnly'
              : resolveFieldMode(path, policy);
            const cur = applicantInfo?.[key] ?? '';
            const base = baselineApplicant?.[key];
            const highlight =
              mode === 'editable' &&
              scalarEqualsSnapshot(cur, base) &&
              String(cur).length > 0;
            return (
              <Col md={6} key={key}>
                <PrefilledFieldShell
                  label={label}
                  htmlId={`req-draft-applicant-${key}`}
                  value={cur == null ? '' : String(cur)}
                  type={type || 'text'}
                  mode={mode}
                  highlightPrefilled={highlight}
                  readOnlyReason={mode === 'readOnly' ? 'read-only' : undefined}
                  onChange={
                    mode === 'editable'
                      ? (v) => onFieldChange(key, v)
                      : undefined
                  }
                />
              </Col>
            );
          })}
        </Row>
        <div className="small text-muted border-top pt-3 mt-1">
          <span className="fw-semibold text-body">
            ID document (from profile):{' '}
          </span>
          {idSummary}
        </div>
      </Card.Body>
    </Card>
  );
}
